// extracted by mini-css-extract-plugin
export var text = "_bf-0";